module.exports = __webpack_public_path__ + "static/media/tone3_good.945f7f75.svg";